import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleCompletionTable = {
  namespaced: true,

  state: {
    name: 'completionTable',
    completionTable: []
  },

  mutations,
  getters,
  actions
}

export default moduleCompletionTable;